"use client";

import { useEffect } from "react";

const LOGIN_URL = "https://app.vawena.ai/login";

/** Redirects to the main app login page so all login flows use one URL. */
export function LoginRedirect() {
  useEffect(() => {
    window.location.href = LOGIN_URL;
  }, []);
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#020D30] text-white">
      <p className="text-white/80">Redirecting to login…</p>
    </div>
  );
}
